import Vue from 'vue';
export const CompanyEventBus = new Vue();

export const ADD_EDIT_COMPANY = 'add-edit-company';
export const GET_COMPANIES = 'get-companies';
